var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    viewBox: "0 0 11 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.747.232a.783.783 0 00-1.111 0L3.805 6.07l-2.45-2.458A.8.8 0 10.244 4.763l3.005 3.005a.783.783 0 001.111 0l6.387-6.382a.783.783 0 000-1.151z"
  })));
}

export default SvgCheckBlack;